import { UAParser } from 'ua-parser-js';

function getDeviceInfo() {
  let ua = new UAParser(navigator.userAgent),
    os = ua.getOS(),
    device = ua.getDevice(),
    browser = ua.getBrowser(),
    repDeviceInfo = '',
    repBrowserInfo = '';

  if (device.model) {
    repDeviceInfo += device.vendor + ' ' + device.model + ' - ';
  }
  repDeviceInfo += os.name + ' ' + os.version;
  repBrowserInfo = browser.name + ' ' + browser.version;

  return {
    repDeviceInfo,
    repBrowserInfo,
    sourceDomain: window.location.hostname,
  };
}

export default getDeviceInfo();



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/DeviceInfoUtil.js